import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import backgroundImage from "../../images/location_new/fold2/Bg_react_dubai.webp";
import { Link } from "gatsby";

function CaseSection(props) {
  return (
    <div
      className="common_section p-100"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={6} xl={5} xxl={6} className="my-auto">
            <div className="example" data-text="London">
              <h2>
                Cross-Platform Domination with Our Custom-made React Native
                Mobile App Development Services
              </h2>
            </div>
            <p>
              Start your journey towards success with TekRevol, where we
              specialize in providing unmatched multi-platform solutions. Our
              React Native mobile app development company reform opportunities,
              warranting productivity and effectiveness. Work together with our
              expert team and accomplish the accolades that differentiate us
              among the honored ranks of React Native app development companies.
              Make your app reliable and innovative with TekRevol as your
              trusted partner on the path to attain your digital goals.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              target="_blank"
              rel="noopener noreferrer"
            >
              Book A Free Consultation!
            </Link>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default CaseSection;
